import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ic-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockComponent {
  @Input() name = '';
  @Input() line = false;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/layout/block/block.component.ts